(()=>{
const r=document.querySelector('[data-ka]')||document;
/* TOC (UA section only) */
const t=r.querySelector('[data-ka-toc]');const mq=matchMedia('(max-width:899px)');
if(t&&mq.matches)t.open=false;
const links=t?[...t.querySelectorAll('a')]:[];
if(links.length&&'IntersectionObserver'in window){const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting)links.forEach(l=>l.classList.toggle('is-active',l.hash==='#'+e.target.id))}),{rootMargin:'0px 0px -70% 0px'});
links.forEach(l=>{const h=document.getElementById(l.hash.slice(1));h&&io.observe(h);l.addEventListener('click',()=>{if(mq.matches)t.open=false})})}
r.querySelectorAll('[data-ka-copy]').forEach(b=>b.addEventListener('click',async()=>{try{await navigator.clipboard.writeText(b.dataset.url);b.textContent=b.dataset.done}catch(e){}}));

/* Variant -> price */
document.querySelectorAll('.ka-select').forEach(s=>s.addEventListener('change',()=>{const p=s.closest('.ka-card').querySelector('[data-ka-price]');const o=s.selectedOptions[0];if(p&&o)p.textContent=o.dataset.price}));

/* Cart counter of the theme (Venture-like: .site-header__cart-indicator.hide). Override via window.KayerArticle.updateCart */
const root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
async function updateCart(){
  try{const c=await (await fetch(root+'cart.js',{headers:{Accept:'application/json'}})).json();
    document.querySelectorAll('.site-header__cart-indicator').forEach(i=>i.classList.toggle('hide',c.item_count===0));
    document.querySelectorAll('[data-cart-count],.cart-count,#CartCount').forEach(i=>{i.textContent=c.item_count;i.classList.toggle('hide',c.item_count===0)});
    document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart:c}}));
    document.dispatchEvent(new CustomEvent('kayer:cart:added',{detail:{cart:c}}));
  }catch(e){}
}
window.KayerArticle=Object.assign({updateCart},window.KayerArticle||{});

/* AJAX add with fallback: if fetch fails hard we submit the form normally */
document.querySelectorAll('form[data-ka-add]').forEach(f=>f.addEventListener('submit',async ev=>{
  if(!window.fetch)return; ev.preventDefault();
  const b=f.querySelector('button'),msg=f.querySelector('.ka-card__msg');
  if(b.disabled)return; b.disabled=true;b.classList.add('is-loading');b.textContent=b.dataset.loading;if(msg)msg.textContent='';
  try{
    const res=await fetch(root+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(f)});
    const data=await res.json().catch(()=>({}));
    if(!res.ok)throw new Error(data.description||data.message||b.dataset.error);
    b.classList.remove('is-loading');b.classList.add('is-added');b.textContent=b.dataset.added;
    await window.KayerArticle.updateCart();
    setTimeout(()=>{b.classList.remove('is-added');b.textContent=b.dataset.label;b.disabled=false},2500);
  }catch(e){
    b.classList.remove('is-loading');b.classList.add('is-error');b.textContent=b.dataset.error;if(msg)msg.textContent=e.message||'';
    setTimeout(()=>{b.classList.remove('is-error');b.textContent=b.dataset.label;b.disabled=false},3000);
  }
}));

/* Sticky bar: show after the cover/header leaves viewport, hide near products block, or when a cookie banner is visible */
const st=document.querySelector('[data-ka-sticky]');
if(st&&'IntersectionObserver'in window&&mq.matches){
  const start=document.querySelector('[data-ka-sticky-start]')||document.querySelector('.ka-cover,.ka-head,h1');
  const stop=document.querySelector('[data-ka-products]');
  let past=false,nearStop=false;
  const cookieVisible=()=>{const c=document.querySelector('#shopify-pc__banner,.shopify-pc__banner__dialog,[id*="cookie" i][class*="banner" i]');return !!(c&&c.offsetParent!==null)};
  const sync=()=>{const on=past&&!nearStop&&!cookieVisible();st.classList.toggle('is-on',on);st.setAttribute('aria-hidden',on?'false':'true');st.querySelectorAll('a,button').forEach(x=>x.tabIndex=on?0:-1);document.documentElement.classList.toggle('ka-sticky-on',on)};
  start&&new IntersectionObserver(([e])=>{past=!e.isIntersecting&&e.boundingClientRect.top<0;sync()}).observe(start);
  stop&&new IntersectionObserver(([e])=>{nearStop=e.isIntersecting||e.boundingClientRect.top<0;sync()},{rootMargin:'0px 0px 80px 0px'}).observe(stop);
  setInterval(sync,2000);
}
})();
